import { useEffect, useState } from 'react';
import ptBR from 'antd/lib/locale/pt_BR';
import esES from 'antd/lib/locale/es_ES';
import 'dayjs/locale/pt';
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import i18n from '../i18n';

function resolveLocales(lng: string) {
  const norm = lng.toLowerCase();
  if (norm.startsWith('es')) {
    dayjs.locale('es');
    return esES;
  }
  dayjs.locale('pt-br');
  return ptBR;
}

export function useAntdLocale() {
  const [locale, setLocale] = useState(resolveLocales(i18n.language));

  useEffect(() => {
    const handleLangChange = (lng: string) => setLocale(resolveLocales(lng));
    i18n.on('languageChanged', handleLangChange);
    return () => i18n.off('languageChanged', handleLangChange);
  }, []);

  return locale;
}
